module.exports = __webpack_public_path__ + "static/media/004yhkgl.b9a628f2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/004yhkgl.jpg
// module id = 628
// module chunks = 0 1